export const NUMERIC = "required|numeric";
export const ALPHA = "required|alpha";
export const ALPHA_SPACE = "required|alpha_space";
export const ALPHA_NUM = "required|alpha_num";
export const ALPHA_NUM_DASH = "required|alpha_num_dash";
export const ALPHA_NUM_SPACE = "required|alpha_num_space";
export const ALPHA_NUM_SPACE_DASH = "required|alpha_num_dash_space";
export const ARRAY = "required|array";
export const BOOLEAN = "required|boolean";
export const CARD_EXP = "required|card_exp";
export const CARD_NUM = "required|card_num";
export const CURRENCY = "required|currency";
export const DATE = "required|date";
export const EMAIL = "required|emailRegex|emailMerchantRegex";
export const MERCHANTFIRSTNAME = "required|merchantFirstNameRegex";
export const MERCHANTLASTNAME = "required|merchantLastNameRegex";
export const INTEGER = "required|integer";
export const PHONE = "required|phone";
export const REQUIRED = "required|required";
export const STRING = "required|string";
export const URL = "brandUrlValidator";
export const REGEX_ALPHANUM_SPLCHAR = "required|regex:/^W_@./#&+-]*$/";
export const NUMBER_MIN = "required|numeric|min:5|max:5";
export const EXTENSION_REGEX = "numeric|min:0|max:5";
export const ALPHA_NUMERIC_WITH_MUST_ALPHA =
  "regex:([a-zA-Z0-9 ]*[a-zA-Z]+[a-zA-Z0-9 ]*)$";
export const CONTACT_TYPE = "regex:([A-Za-z0-9 ]+$)";
export const ONLY_DIGITS = /^[0-9]\d{0,9}(\.\d{1,1})?%?$/;
export const DIGITS_ALLOWANCE_RATE = /^(?:9(?:\.0)?|[1-9](?:\.[0-9])?|0?\.[1-9])$/;
export const OPEN_RA_NUMERIC = "openRANumeric";
export const BRANDNAME = "required|brandNameValidator";
export const MA_PRODUCT_TYPE_VALIDATION = "required|max:30";
export const VDF = "required|VDF";
export const ALPHA_NUMERIC_WITH_MUST_ALPHA_NO_SPEC_CHAR =
  "regex:^([a-zA-Z0-9 ]*[a-zA-Z]+[a-zA-Z0-9 ]*)$";
export const ALPHA_NUMERIC_WITH_MUST_ALPHA_NO_SPEC_CHAR_REGEX = /^([a-zA-Z0-9 ]*[a-zA-Z]+[a-zA-Z0-9 ]*)$/;
export const ALPHA_NUMERIC_WITH_MUST_ALPHA_SPEC_CHAR =
  "regex:^([A-Za-z](?!.*[-_]$)(?!.*[-_ ]{2})[a-zA-Z0-9 _-]*[A-Za-z0-9 ]*)$";
export const ALPHA_NUMERIC_WITH_MUST_ALPHA_SPEC_CHAR_REGEX = /^([A-Za-z](?!.*[-_]$)(?!.*[-_ ]{2})[a-zA-Z0-9 _-]*[A-Za-z0-9 ]*)$/;
